module.exports = __webpack_public_path__ + "static/media/12.fe9f81f3.jpg";